import { render, staticRenderFns } from "./CoinRotateBottomLargeIcon.vue?vue&type=template&id=38306f20&"
import script from "./CoinRotateBottomLargeIcon.vue?vue&type=script&lang=ts&"
export * from "./CoinRotateBottomLargeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports